// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentAdministrativeProofApi,
  IAssessmentAdministrativeProofApiRequest,
  IAssessmentAdministrativeProofApiGetListAttrs,
  IAssessmentAdministrativeProofApiListResponse,
} from 'interfaces/back-office/assessment/registration/administrative-proof/administrative-proof-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class AssessmentAdministrativeProofApi
  extends BaseApi<IAssessmentAdministrativeProofApi>
  implements IAssessmentAdministrativeProofApiRequest
{
  readonly url = ApiConstantHc.ASSESSMENT_REGISTRATION_ADMINISTRATIVE_PROOF_URL
  private assessmentRegistrationRelevantProofUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get assessment relevant proof list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentAdministrativeProofApiGetListAttrs} payload
   *
   * @return {Promise<IAssessmentRelevantProofApiListResponse>} Promise<IAssessmentRelevantProofApiListResponse>
   */
  async assessmentAdministrativeProof_getList(
    payload: IAssessmentAdministrativeProofApiGetListAttrs,
  ): Promise<IAssessmentAdministrativeProofApiListResponse> {
    return this.GET(
      `${this.assessmentRegistrationRelevantProofUrl}/${payload.params.assessmentId}`,
      { ...payload.requestConfig },
    )
  }
}
